import { api } from '@/api'
import Button from '@/components/Button'
import Checkbox from '@/components/Checkbox'
import Input from '@/components/Input'
import InputPhone from '@/components/InputPhone'
import { useFormik } from 'formik'
import { StateSelect } from '@/components/Select'
import { GxForm } from '@garpix/garpix-web-components-react'
import React from 'react'
import { Link } from 'react-router-dom'
import style from '../styles/auth.module.scss'
import { registrationSchema } from '@/utils/schemesFormik'
import Spinner from '@/components/Spinner/Spinner'
import { useConfig } from '@/hooks'

const RegistrationForm = ({ redirectPage = '/' }): React.ReactElement => {
  const config = useConfig()

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: registrationSchema,
    initialValues: {
      login: '',
      email: '',
      password: '',
      first_name: '',
      // last_name: '',
      // second_name: '',
      personal_birthday: '',
      personal_state: '',
      personal_city: '',
      // uf_school: '',
      personal_phone: '',
      confirm_password: '',
      apiError: ''
    },
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit (values, { setSubmitting, setErrors }) {
      api
        .register({
          login: values.login,
          email: values.email,
          password: values.password,
          first_name: values.first_name,
          // last_name: values.last_name,
          // second_name: values.second_name,
          personal_birthday: values.personal_birthday,
          personal_state: values.personal_state,
          personal_city: values.personal_city,
          // uf_school: values.uf_school,
          personal_phone: values.personal_phone
        })
        .then(() => {
          api
            .login({
              login: values.login,
              password: values.password
            })
            .then(() => {
              setSubmitting(false)
              window.location.href = redirectPage
            })
            .catch((err: any) => {
              setErrors({ apiError: err?.response?.data?.errorText })
              setSubmitting(false)
            })
        })
        .catch((err: any) => {
          setErrors({ apiError: err?.response?.data?.errorText })
          setSubmitting(false)
        })
    }
  })

  const handleChangePhone = async (e): Promise<void> => {
    const value = e.detail.value
    await formik.setFieldValue('personal_phone', value)
  }

  const onSubmit = formik.submitForm

  return (
    <GxForm onGx-submit={onSubmit}>
      <div className={style.form__reg}>
        <Input
          name='login'
          label='Логин:'
          type='text'
          required
          value={formik.values.login}
          onGx-input={formik.handleChange}
          error={formik.errors.login}
          className={style.form__field}
        />
        {/* <Input
          name='last_name'
          label='Фамилия:'
          type='text'
          required
          value={formik.values.last_name}
          onGx-input={formik.handleChange}
          error={formik.errors.last_name}
          className={style.form__field}
        /> */}
        <Input
          name='first_name'
          label='Имя:'
          placeholder=''
          type='text'
          required
          value={formik.values.first_name}
          onGx-input={formik.handleChange}
          error={formik.errors.first_name}
          className={style.form__field}
        />
        {/* <Input
          name='second_name'
          label='Отчество:'
          type='text'
          value={formik.values.second_name}
          onGx-input={formik.handleChange}
          error={formik.errors.second_name}
          className={style.form__field}
        /> */}
        <Input
          name='personal_birthday'
          label='Дата рождения:'
          type='text'
          placeholder='дд.мм.гггг'
          required
          value={formik.values.personal_birthday}
          onGx-input={formik.handleChange}
          error={formik.errors.personal_birthday}
          className={style.form__field}
        />
        <StateSelect
          name='personal_state'
          label='Область/край:'
          required
          value={formik.values.personal_state}
          onGx-change={formik.handleChange}
          error={formik.errors.personal_state}
          className={style.form__field}
        />
        <Input
          name='personal_city'
          label='Город:'
          type='text'
          required
          value={formik.values.personal_city}
          onGx-input={formik.handleChange}
          error={formik.errors.personal_city}
          className={style.form__field}
        />
        {/* <Input
          name='uf_school'
          label='Учебное заведение:'
          type='text'
          required
          value={formik.values.uf_school}
          onGx-input={formik.handleChange}
          error={formik.errors.uf_school}
          className={style.form__field}
        /> */}
        <InputPhone
          name='personal_phone'
          label='Телефон:'
          type='text'
          value={formik.values.personal_phone}
          onGx-change={handleChangePhone}
          error={formik.errors.personal_phone}
          className={style.form__field}
        />
        <Input
          name='email'
          label='Почта:'
          type='email'
          required
          value={formik.values.email}
          onGx-input={formik.handleChange}
          error={formik.errors.email}
          className={style.form__field}
        />
        <Input
          name='password'
          label='Пароль:'
          type='password'
          placeholder='Минимум 8 символов'
          required
          value={formik.values.password}
          onGx-input={formik.handleChange}
          error={formik.errors.password}
          className={style.form__field}
        />
        <Input
          name='confirm_password'
          label='Повтори пароль:'
          type='password'
          required
          value={formik.values.confirm_password}
          onGx-input={formik.handleChange}
          error={formik.errors.confirm_password}
          className={style.form__field}
        />
      </div>
      <Checkbox required className={style.form__policy_checkbox}>
        Для продолжения регистрации попроси родителей ознакомиться с{' '}
        <Link to={config.personal_data_policy} className={style.form__policy}>
          политикой обработки персональных данных
        </Link>
      </Checkbox>
      <Button
        wide
        highlight
        size='extralarge'
        type='submit'
        disabled={formik.isSubmitting}
      >
        {formik.isSubmitting ? <Spinner /> : 'Зарегистрироваться'}
      </Button>
      {formik?.errors?.apiError === ''
        ? undefined
        : (
          <span className={`${style.form__error} ${style['form__error--mt']}`}>
            {formik?.errors?.apiError}
          </span>
          )}
    </GxForm>
  )
}

export default RegistrationForm
